export default __webpack_public_path__ + "static/media/Dipanjan De.177ecc83.png";